import templateUrl from "./user-note-main.html";

export const userNoteMainComponent = {
  bindings: {
    action: "@",
    title: "@",
    details: "<",
  },
  templateUrl,

  controller: class UserNoteMainComponent {
    constructor(toastr, $window, $stateParams, UserService, Constants) {
      "ngInject";
      this.$window = $window;
      this._toastr = toastr;
      this.Constants = Constants;
      this.userService = UserService;
      this.$stateParams = $stateParams;
    }
    $onInit() {
      this.disableButtons = false;
      this.maxDescriptionChars = 1000;
      this.plainDescription = " ";
    }
    goBack() {
      this.$window.history.back();
    }
    onCancel() {
      this.goBack();
    }
    onSubmit() {
      if (this.plainDescription.trim().length <= this.maxDescriptionChars) {
        this.disableButtons = true;
        this.userService
          .sendUserNoteById(
            { note: this.details.note },
            { membersId: this.$stateParams.id }
          )
          .then((_) => {
            this._toastr.success(
              `Note ${this.action === "add" ? "added" : "updated"} successfully`
            );
            this.goBack();
          })
          .catch((err) => {
            this.disableButtons = false;
            this._toastr.error(err);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/user/user-note-main/user-note-main.component.js